import React, { useState, useEffect } from 'react';
import PlanUpdates from './PlanUpdates.js';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import ManageAlgos from './ManageAlgos.js'
import { useParams } from 'react-router-dom';
import PlanRecommendations from './PlanRecommendations.js';
import CircuitBreaker from './CircuitBreaker.js';
import PlanWizard from './PlanWizard.js';
import PlanSizing from './PlanSizing.js';

function UpdatePlan(props) {

    let { activeTab } = useParams();
    const [tab, setTab] = useState(activeTab ? activeTab : 'update');

    useEffect(() => {
        (async function () {
        })();
    }, []);

    const handleChangeTab = (event, newTab) => {
        setTab(newTab);
    };

    return (
        <div>
            <>
                <Box sx={{ bgcolor: '#F0F0F0', border: 1, borderBottom: 0, borderColor: 'black', borderRadius: 0 }}>
                    <Tabs
                        value={tab}
                        onChange={handleChangeTab}
                        textColor="secondary"
                        indicatorColor="secondary"
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab value="update" label="Update Plan" />
                        <Tab value="recommendations" label="Recommendations" />
                        <Tab value="sizing" label="Sizing" />
                        <Tab value="changes" label="Change History" />
                        <Tab value="wizard" label="Wizard" />
                        <Tab value="circuitBreaker" label="Circuit Breaker" />
                    </Tabs>
                </Box>
                <br></br>

                {tab === "update" ?
                    <>
                        <ManageAlgos onAlgoSelected={props.onAlgoSelected} onAlertSelected={props.onAlertSelected} planId={props.planId} userId={props.userId} role={props.role} mobileView={props.mobileView} />
                    </>
                    : null}
                {tab === "changes" ?
                    <>
                        <PlanUpdates onAlertSelected={props.onAlertSelected} planId={props.planId} onAlgoSelected={props.onAlgoSelected} />
                    </>
                    : null}
                {tab === "recommendations" ?
                    <>
                        <PlanRecommendations onAlertSelected={props.onAlertSelected} planId={props.planId} onAlgoSelected={props.onAlgoSelected} />
                    </>
                    : null}
                {tab === "sizing" ?
                    <>
                        <PlanSizing planId={props.planId} />
                    </>
                    : null}
                {tab === "circuitBreaker" ?
                    <>
                        <CircuitBreaker planId={props.planId} role={props.role} userId={props.userId} />
                    </>
                    : null}
                {tab === "wizard" ?
                    <>
                        <PlanWizard planId={props.planId} role={props.role} userId={props.userId} />
                    </>
                    : null}
            </>
        </div>
    );
}

export default UpdatePlan;